import { Flex, Heading } from '@blockanalitica/ui';
import { ReactNode } from 'react';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';

type PageProps = {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
};

export default function Page({ title, actions, children }: PageProps) {
  return (
    <Flex flexDirection="column" gap="m">
      <Flex flexDirection="column" gap="xs">
        <Breadcrumbs />
        {title || actions ? (
          <Flex
            justifyContent="space-between"
            gap="xs-s"
            flexWrap={['wrap', 'nowrap']}
            flexDirection={['column', 'row']}>
            {title ? (
              <Flex
                justifyContent="flex-start"
                alignItems="center"
                gap="2xs-xs">
                {typeof title === 'string' ? (
                  <Heading fontSize="6">{title}</Heading>
                ) : (
                  title
                )}
              </Flex>
            ) : null}

            {actions ? (
              <Flex
                alignItems="center"
                justifyContent="center"
                flexDirection={['row', 'row']}
                gap="xs-s"
                flexWrap={['wrap', 'wrap', 'nowrap']}>
                {actions}
              </Flex>
            ) : null}
          </Flex>
        ) : null}
      </Flex>

      {children}
    </Flex>
  );
}
